export default function cloudFunctionsEndpoint() {
  const isDevelopment = process.env.REACT_APP_STAGE === "development"
  const isStaging = process.env.REACT_APP_STAGE === "staging"
  const isProduction = process.env.REACT_APP_STAGE === "production"
  const isQAProduction = process.env.REACT_APP_STAGE === "qaproduction"

  if (isProduction) {
    return process.env.REACT_APP_CLOUD_FUNCTIONS_PROD
  }
  if (isStaging) {
    return process.env.REACT_APP_CLOUD_FUNCTIONS_STAGE
  }
  if (isDevelopment) {
    return process.env.REACT_APP_CLOUD_FUNCTIONS_DEV
  }
  if (isQAProduction || process.env.REACT_APP_LOCALHOST==="QA") {
    return process.env.REACT_APP_CLOUD_FUNCTIONS_QAPROD
  }

  return process.env.REACT_APP_CLOUD_FUNCTIONS_DEV
  // return process.env.REACT_APP_CLOUD_FUNCTIONS_LOCAL // ** TEMP
}
